import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBan } from '@fortawesome/pro-regular-svg-icons';

export type AccountInactiveReason = 'company' | 'user';

/**
 * Pantalla a la que redirige el JwtInterceptor ante un 403 company_inactive /
 * user_inactive (middleware EnsureAccountIsActive). La sesión ya está cerrada
 * cuando se llega aquí: no hace ninguna petición a la API.
 */
@Component({
  selector: 'app-account-inactive',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './account-inactive.component.html',
})
export class AccountInactiveComponent implements OnInit {
  readonly faBan = faBan;

  reason: AccountInactiveReason = 'company';
  companyName = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    this.reason = params.get('reason') === 'user' ? 'user' : 'company';
    this.companyName = (params.get('company') ?? '').trim();
  }

  get title(): string {
    return this.reason === 'user'
      ? 'Tu usuario está desactivado'
      : 'La cuenta de tu empresa está desactivada';
  }

  get message(): string {
    if (this.reason === 'user') {
      return 'No es posible acceder a ARDIA mientras tu usuario esté desactivado. Tu información, conexiones e histórico se conservan. Si necesitas volver a entrar, habla con el administrador de tu empresa.';
    }
    const company = this.companyName ? `la cuenta de ${this.companyName}` : 'la cuenta de tu empresa';
    return `No es posible acceder a ARDIA mientras ${company} esté desactivada. Toda tu información, conexiones e histórico se conservan.`;
  }

  backToLogin(): void {
    this.router.navigate(['/']);
  }
}
